import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";

export default function ChangePasswordPage() {
  const { user, updateUser, logout } = useAuth();
  const nav = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) return toast.error("La password deve avere almeno 8 caratteri");
    if (next !== confirm) return toast.error("Le due password non coincidono");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      updateUser({ must_change_password: false });
      toast.success("Password aggiornata");
      nav("/app");
    } catch (err) { toast.error(formatError(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <Card className="w-full max-w-md border-gray-200">
        <CardContent className="p-8">
          <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
            <KeyRound className="w-6 h-6 text-primary" />
          </div>
          <h2 className="font-display text-2xl font-semibold">Cambia password</h2>
          <p className="text-sm text-muted-foreground mt-1">
            {user?.must_change_password
              ? "Al primo accesso è obbligatorio impostare una nuova password."
              : "Aggiorna la password del tuo account."}
          </p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-wider text-gray-600">Password attuale</Label>
              <Input type="password" required data-testid="cp-current" value={current} onChange={(e) => setCurrent(e.target.value)} className="mt-1.5" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-gray-600">Nuova password (min 8)</Label>
              <Input type="password" required data-testid="cp-new" value={next} onChange={(e) => setNext(e.target.value)} className="mt-1.5" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-gray-600">Conferma nuova password</Label>
              <Input type="password" required data-testid="cp-confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5" />
            </div>
            <div className="flex gap-2 pt-2">
              <Button type="submit" disabled={busy} data-testid="cp-submit" className="rounded-full flex-1 h-11">
                {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Aggiorna
              </Button>
              <Button type="button" variant="ghost" onClick={() => { logout(); nav("/login"); }} data-testid="cp-cancel">
                Esci
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
